export type { SideModalProps } from './interface'
export { SideModal } from './side-modal'
